import React, { useCallback, useState } from 'react';
import { Upload, message, Icon } from 'antd';

import { strFromU8 } from 'fflate';

import { BulkUploadButton } from '../TemplateSection/styles';
import { uploadDKVDesignXML } from '../../utils/services/uploadAPI';

const DKVImport = () => {

  const [loading, setLoading] = useState(false);

  const onUploadXML = useCallback(async (event) => {
    setLoading(true);
    console.log("Event :: ", event.name, event);
    /*const XMLFile = await event.text();
    console.log({ XMLFile });*/

    const response = await uploadDKVDesignXML(event, event.name);
    console.log({ response });

    if (response?.status !== 200) {
      message.error("Unable to generate design script!!");
    }

    setLoading(false);
  }, []);

  return (
    <Upload
      accept=".scd"
      showUploadList={false}
      className="dkvUpload"
      action={onUploadXML}
    >
      <BulkUploadButton style={{ margin: 'auto', width: '50%' }}>
        <p className={'downloadZip'} style={{ visibility: loading ? 'visible' : 'hidden' }}>
          <Icon
            type={'loading'}
            style={{ marginRight: '5px', fontSize: '20px', color: '#FC6E51' }}
          />
        </p>
        <p className="import">
          {'Upload your SCD file'}
        </p>
        <p className="desc">
          {'Once you obtain the .zip file, use it with DocStudio\'s import feature to kickstart your design'}
        </p>
      </BulkUploadButton>
    </Upload>
  );
}

export default DKVImport;